import FaceAdd16 from '@carbon/icons-react/es/face--add/16';
import { Tooltip } from 'antd';
import { Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import React, { FC, useEffect, useState } from 'react';
import Popover from 'react-tiny-popover';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';
import { queueMacrotask } from 'utils/macrotask';
import styles from './emoji-picker.module.css';

interface EmojiPickerProps {
  enabled: boolean;
  onSelect: (emoji: string) => void;
  icon?: React.ReactNode;
  hideHoverEffect?: boolean;
}

export const EMOJI_NODE_CLASS = 'emoji-mart';

export const EmojiPicker: FC<EmojiPickerProps> = ({
  enabled,
  onSelect,
  icon,
  hideHoverEffect,
}) => {
  const [opened, setOpened] = useState(false);
  const addEmojiCaption = useTranslation('rte.plugins.emoji.add_caption');
  const selectEmojiCaption = useTranslation('rte.plugins.emoji.select_caption');

  useEffect(() => {
    if (!opened) {
      return;
    }
    queueMacrotask(() =>
      (
        document.querySelector('.emoji-mart-search input') as HTMLInputElement
      )?.focus(),
    );
  }, [opened]);

  return (
    <Popover
      isOpen={opened}
      position={['top', 'bottom', 'left', 'right']}
      padding={10}
      onClickOutside={() => setOpened(false)}
      content={
        opened ? (
          <div className={styles.wrapper}>
            <Picker
              native
              autoFocus
              showSkinTones={false}
              useButton={false}
              emoji="rocket"
              title={selectEmojiCaption}
              onSelect={(emoji) => {
                onSelect(emoji.id!);
                setOpened(false);
              }}
            />
          </div>
        ) : (
          <></>
        )
      }
    >
      {(ref) => (
        <Tooltip title={addEmojiCaption}>
          <Button
            data-cy="chat.add.emoji"
            type="text"
            ref={ref}
            disabled={!enabled}
            aria-label={addEmojiCaption}
            icon={icon || <FaceAdd16 className="carbon-icon" />}
            onClick={() => setOpened(!opened)}
            hideHoverEffect={hideHoverEffect}
          />
        </Tooltip>
      )}
    </Popover>
  );
};
